<div class="flex" *ngIf="canFreeze || canReleaseOrReverse">
    <button *ngIf="canFreeze"
            pButton pRipple
            type="button"
            label="Freeze"
            class="p-button-warning mr-2"
            [disabled]="isFreezeTransactionButtonDisabled"
            (click)="openDialogFreezeTransaction()"></button>

    <button *ngIf="canReleaseOrReverse"
            pButton pRipple
            type="button"
            label="Release Hold"
            class="p-button-success mr-2"
            [disabled]="isReleaseHoldButtonDisabled"
            (click)="releaseHold()"></button>

    <button *ngIf="canReleaseOrReverse"
            pButton pRipple
            type="button"
            label="Reverse"
            class="p-button-danger"
            [disabled]="isReverseHoldButtonDisabled"
            (click)="openDialogReverseHold()"></button>
</div>

<p-dialog [(visible)]="showDialogFreezeTransaction"
          [modal]="true"
          header="Freeze Transaction"
          [style]="{width: '500px'}"
          [draggable]="false"
          [resizable]="false">
    <div class="m-0 flex flex-column">
        <div *ngIf="freezeErrorMessage"
             class="p-3 mb-3 border-round flex align-items-start gap-2"
             style="background-color: #fde8e8; border: 1px solid #f5b5b5; color: #b91c1c;">
            <i class="pi pi-exclamation-triangle mt-1"></i>
            <span>{{ freezeErrorMessage }}</span>
        </div>
        <p class="mb-3">Are you sure you want to freeze this transaction? The funds will be put on hold.</p>
        <label class="mb-2">Reason for freezing</label>
        <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="explanationForFreeze" class="w-full"></textarea>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" class="p-button-text" (click)="closeDialogFreezeTransaction()"></button>
        <button pButton pRipple label="Freeze" class="p-button-warning"
                (click)="freezeTransaction()"
                [disabled]="!explanationForFreeze || isFreezeTransactionButtonDisabled"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="showDialogReverseHold"
          [modal]="true"
          header="Reverse Transaction"
          [style]="{width: '500px'}"
          [draggable]="false"
          [resizable]="false">
    <div class="m-0 flex flex-column">
        <div *ngIf="reverseErrorMessage"
             class="p-3 mb-3 border-round flex align-items-start gap-2"
             style="background-color: #fde8e8; border: 1px solid #f5b5b5; color: #b91c1c;">
            <i class="pi pi-exclamation-triangle mt-1"></i>
            <span>{{ reverseErrorMessage }}</span>
        </div>
        <p class="mb-3">Are you sure you want to reverse this frozen transaction? This will permanently deduct the funds.</p>
        <label class="mb-2">Reason for reversal</label>
        <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="explanationForReverse" class="w-full"></textarea>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" class="p-button-text" (click)="closeDialogReverseHold()"></button>
        <button pButton pRipple label="Reverse" class="p-button-danger"
                (click)="reverseHold()"
                [disabled]="!explanationForReverse || isReverseHoldButtonDisabled"></button>
    </ng-template>
</p-dialog>
